import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["toggleBackupCodesModal"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H3 } from 'foundations-components/transitional/components/H3';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { CodeEntryForm } from './CodeEntryForm';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BackupCodesModal = _ref => {
  let {
      toggleBackupCodesModal
    } = _ref,
    codeEntryFormProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Modal, {
    children: /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(H3, {
        "aria-level": 1,
        marginBlockEnd: "600",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "twoFactorV4.backupCodes.title"
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "twoFactorV4.backupCodes.description"
      }), /*#__PURE__*/_jsx(CodeEntryForm, Object.assign({}, codeEntryFormProps, {
        closeModal: toggleBackupCodesModal,
        type: "modal"
      }))]
    })
  });
};